export const STRINGS = {
    THIS_APPLIES:"This applies across any ReachIQ accounts you have.",
    FULL_NAME:"Full Name",
    USER_PROFILE:"User Profile",
    
}